<mat-card
  #widgetRef
  [ngClass]="{
    'h-[48rem]': !this.isDialogInstance,
    'h-[90vh]': this.isDialogInstance,
  }"
>
  <!-- we use !p-4 to override mat padding cause its not using padding bottom by default. -->

  <mat-card-header class="flex-1 flex-nowrap justify-between flex-grow-0 !p-4">
    <!-- we set nowrap, to prevent having different header heights by text wrapping -->
    <mat-card-title class="!flex gap-2 text-nowrap items-center">
      @if (name) {
        {{ name }}
      } @else {
        <ng-template [ngTemplateOutlet]="this.title.templateRef" />
      }

      @if (this.title.infoTooltipText) {
        <pm-button
          variant="subdued"
          [pmTooltip]="this.title.infoTooltipText"
          [icon]="infoIcon"
          class="flex items-center"
        />
      }
    </mat-card-title>
    <!-- we use min-h-11 to always have the same height, even if no filters are passed to the card -->
    <div class="justify-end flex flex-nowrap gap-4 min-h-11">
      @if (isLoading) {
        <ng-template [ngTemplateOutlet]="filterSkeleton" />
      } @else {
        <ng-template [ngTemplateOutlet]="header" />
      }
    </div>
  </mat-card-header>
  <mat-divider />
  <mat-card-content class="!flex flex-grow">
    @if (isLoading) {
      <ng-template [ngTemplateOutlet]="chartSkeleton" />
    } @else {
      <ng-template [ngTemplateOutlet]="content" />
    }
  </mat-card-content>
  <!-- see: https://pacemaker-ai.atlassian.net/browse/PM-1524 -->
  <mat-divider />
  <mat-card-actions align="end">
    <ng-template [ngTemplateOutlet]="actions" />
  </mat-card-actions>
</mat-card>

<!-- Loading Skeletons -->
<ng-template #filterSkeleton>
  <div class="w-[13rem] h-11 bg-gray-200 rounded-lg dark:bg-gray-300"></div>
  <div class="w-[13rem] h-11 bg-gray-200 rounded-lg dark:bg-gray-300"></div>
</ng-template>

<ng-template #chartSkeleton>
  <div
    role="status"
    class="flex flex-col w-full p-4 shadow animate-pulse md:p-6"
  >
    <div class="flex items-end m-4 flex-grow">
      <div class="w-full bg-gray-200 rounded-t-lg h-72 dark:bg-gray-300"></div>
      <div
        class="w-full h-56 ms-6 bg-gray-200 rounded-t-lg dark:bg-gray-300"
      ></div>
      <div
        class="w-full bg-gray-200 rounded-t-lg h-72 ms-6 dark:bg-gray-300"
      ></div>
      <div
        class="w-full h-64 ms-6 bg-gray-200 rounded-t-lg dark:bg-gray-300"
      ></div>
      <div
        class="w-full bg-gray-200 rounded-t-lg h-80 ms-6 dark:bg-gray-300"
      ></div>
      <div
        class="w-full bg-gray-200 rounded-t-lg h-72 ms-6 dark:bg-gray-300"
      ></div>
      <div
        class="w-full bg-gray-200 rounded-t-lg h-80 ms-6 dark:bg-gray-300"
      ></div>
    </div>

    <div class="flex m-4 gap-4 self-center max-w-80">
      <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-32"></div>
      <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-32"></div>
      <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 w-36"></div>
      <div class="w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-300"></div>
    </div>
  </div>
</ng-template>
